import styles from './error-modal.module.css'

export function ErrorModal({
  validationErrors,
}: {
  validationErrors: string[] | undefined
}) {
  if (
    !validationErrors ||
    !Array.isArray(validationErrors) ||
    validationErrors.length === 0
  )
    return null

  return (
    <div className={styles.wrapper}>
      <div>
        <h3 className={styles.validationErrorTitle}>
          Before publishing this review please address the errors
        </h3>

        {validationErrors.map((error, index) => (
          <p className={styles.errorItem} key={index}>{`${
            index + 1
          }. ${error}`}</p>
        ))}
      </div>
    </div>
  )
}
